import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FormattedMessage } from "react-intl";
import img1 from "../../assets/images/jtl/img1.png";

const pStyle = {
  fontSize: "18px",
  marginBottom: "16px"
};

export default function TricomaGuide() {
  return (
    <Box>
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="jtl.step1"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <Typography component="p" sx={pStyle}>
        <FormattedMessage
          id="jtl.step2"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <Typography component="p" sx={pStyle}>
        <FormattedMessage
          id="jtl.step3"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <br />
      <img src={img1} style={{ width: "100%" }} />
      <br />
      <br />
      <Typography component="p" sx={pStyle}>
        <FormattedMessage
          id="contactSupport"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
    </Box>
  );
}
